export const CONTACT_MODEL = {
  company: 0,
}

export const COMPANY_CONTACT_TYPE = {
  EMAIL: 1,
  EMERGENCY_PHONE: 6,
  PHONE: 2,
  WEBSITE: 3,
}

export const PROFILE_CONTACT_TYPE = {
  ADDRESS: 400,
  AUTH_EMAIL: 50,
  AUTH_PHONE: 75,
  EMAIL: 300,
  EMERGENCY_PHONE: 200,
  ORDER_EMAIL: 350,
  ORDER_PHONE: 150,
  PHONE: 100,
  WEBSITE: 500,
  WORKING_HOURS: 600,
}
